import axios from 'axios';

const authApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 8000,
});

/**
 * Fa il refresh del token tramite l'endpoint del backend
 * @param {string} refreshToken - Il refresh token di Keycloak
 * @returns {Promise} Ritorna i nuovi token (access_token, refresh_token, expires_in)
 */
export async function refreshAccessToken(refreshToken) {
  try {
    const response = await authApi.post('/api/v1/auth/refresh-token/', {
      refresh_token: refreshToken,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    throw error;
  }
}

export default authApi;
